import BaseService from '@/ecm/common/BaseService.js'
class HealthSystemService {
  baseUrl = 'health-system';
  getHealthSystemStatus = () => BaseService.get({ url: `${this.baseUrl}/status` });
}

export default new HealthSystemService()
